import React from "react";
import PropTypes from "prop-types";
import ListItem from "./ListItem";
import { Draggable } from "react-beautiful-dnd";

const List = ({ customForms, onDelete, onDuplicate, onCopy }) =>
  customForms.map((customForm, index) => (
    <Draggable index={index} draggableId={customForm.id} key={customForm.id}>
      {(provided, snapshot) => (
        <ListItem
          provided={provided}
          snapshot={snapshot}
          customForm={customForm}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
          onCopy={onCopy}
        />
      )}
    </Draggable>
  ));

List.propTypes = {
  customForms: PropTypes.array,
  onDelete: PropTypes.func,
  onDuplicate: PropTypes.func,
  onCopy: PropTypes.func
};

export default List;
